import React from "react";
import { Box, Divider } from "@mui/joy";
import { headerLeftGroupSx, headerRowSx } from "../../../styles/globalStyles";

export type TrainingsTemplatePageHeaderProps = {
  left: React.ReactNode;
  right: React.ReactNode;
};

export default function TrainingsTemplatePageHeader({
  left,
  right,
}: TrainingsTemplatePageHeaderProps) {
  return (
    <Box sx={{ flexShrink: 0, paddingBottom: 2 }}>
      <Box sx={headerRowSx}>
        <Box sx={headerLeftGroupSx}>{left}</Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>{right}</Box>
      </Box>
      <Divider sx={{ marginTop: "10px" }} />
    </Box>
  );
}
